import { useLocation } from "react-router-dom";
import NavBarManager from "../../Pages/Manager/NavBarManager";
import Header from "../../Pages/Shared/Header";
import { decryptToken } from "../../Services/Encryption/EncryptionParams";
import Navbar from "../../Pages/Shared/NavBar";
import { useSelector } from "react-redux";

const MainLayoutManager = ({ children }) => {
  // to read params url
  const location = useLocation();
  // استخراج GUID باستخدام Regular Expression
  const match = window.location.pathname; // قراءة النص بعد أول "/"
  const encryptedToken = match.split("/");
  console.log(encryptedToken, "slkdslkdlksdl");
  var guid =
    encryptedToken[encryptedToken.length - 1] != null
      ? decryptToken(encryptedToken[encryptedToken.length - 1])
      : null;

      var pathName=window.location.pathname.split("/").includes("manager");
console.log(pathName,"pathName");

  return (
    <>
      <Header location={guid?"manager":""} />
      {/* <NavBarManager /> */}
      {guid ? <Navbar location="manager" /> : <NavBarManager />}
      <main>{children}</main>
    </>
  );
};
export default MainLayoutManager;
